import React from 'react'
import { ReactComponent as Lock } from '../../../assets/icons/portfolio/redLock.svg'
import Header from '../../../components/header/Header'
import Button from '../../../components/button/Button'
import './PortfolioError.css'
import { useNavigate } from 'react-router-dom'
import {useTranslation} from "react-i18next";


const PortfolioError = () => {
    const {t} = useTranslation()
  const navigate = useNavigate()
  return (
    <div className='PortfolioError'>
        <Header  hasMenu2={true}/>

        <div className="PortfolioErrorWrapper">
            <div className="Error">
                <div className="errorData">
                    <Lock/>
                    <h2>{t("portfolioError.notAccess")}</h2>
                </div>
                <h3>{t("portfolioError.supportService")}</h3>
                <Button text={t("portfolioError.back")} onClick={()=>navigate("/")} />
            </div>
        </div>
    </div>
  )
}

export default PortfolioError